import React from 'react';
import { uploadStatusPresentation } from '@/constants/upload';
import { cn } from '@/lib/utils';
import type { UploadStatus } from '@hooks/useDocumentUpload';

interface UploadStatusIconProps {
  status: UploadStatus;
  className?: string;
}

/**
 * Decorative by design: every place this renders shows an UploadStatusBadge or
 * the file name beside it, so announcing the icon would just repeat them.
 */
const UploadStatusIcon: React.FC<UploadStatusIconProps> = ({ status, className }) => {
  const { Icon, iconClass } = uploadStatusPresentation(status);

  return (
    <Icon aria-hidden className={cn('size-4 shrink-0', iconClass, className)} strokeWidth={1.9} />
  );
};

export default UploadStatusIcon;
